import React from "react";
import { Image, Col, Row, Tabs } from "antd";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import leann from '../../images/team/Hopper_5x7.jpg';
import kristine from '../../images/team/Evans_5x7.jpg';
import mark from '../../images/team/McConnell_5x7.jpg';
import amanda from '../../images/team/Sesser_5x7.jpg';
import shannon from '../../images/team/Westlake_5x7.jpg';
import ethan from '../../images/team/Liang_5x7.jpg';
import reshma from '../../images/team/Mandli_5x7.jpg';
import lee from '../../images/team/Hathcock_5x7.jpg';
import anthony from '../../images/team/Collini_5x7.jpg';
import daniel from '../../images/team/Egerson_5x7.jpg';
import dixie from '../../images/team/Cartwright_5x7.jpg';
import tracey from '../../images/team/DuBard_5x7.jpg';
import rishita from '../../images/team/Garg_5x7.jpg';
import sathish from '../../images/team/Samiappan_5x7.jpg';
import bradly from '../../images/team/Thornton_5x7.jpg';
import './style.css';

function ProjectTeam(){
    return(
      <>
        <Header />
          <Tabs
            defaultActiveKey="1"
            type="card"
            size="middle"
            className="team-tabs"
            items={[
              {
                label: "Project Team",
                key: "1",
                children: (
                  <>
                    <Row>  
                      <Col span={16} offset={2}>
                        <p className="mt-3"><b>Kristine Evans,</b> Project Investigator</p> 
                        <p className="mt-3">
                          Kristine Evans is a Project Investigator of the CRP Menu project. She is the Associate Director of the Geosystems Research Institute and an Associate Professor with the Department of Wildlife, Fisheries, and Aquaculture. Her research interests include conservation design, avian ecology, geospatial applications, landscape conservation, strategic habitat conservation, agricultural conservation, and biological monitoring.
                          <br/><br/>
                          <i>Email:</i> <a className="email-address" href="mailto:kristine.evans@msstate.edu">kristine.evans@msstate.edu</a>
                        </p>
                      </Col>
                      <Col span={3} offset={1}>
                        <Image src={kristine} alt="kristine" rootClassName="mt-3 teamimg"/>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={16} offset={2}>
                        <p  className="mt-3"><b>Mark McConnell,</b> Project Investigator</p> 
                        <p  className="mt-3">
                          Mark McConnell is a Project Investigator of the CRP Menu project. He is an Assistant Professor of Upland Birds in the Department of Wildlife, Fisheries, and Aquaculture at Mississippi State University. His research interest includes conservation in working landscapes, gamebird ecology, and precision agriculture.
                          <br/><br/>
                          <i>Email:</i> <a className="email-address" href="mailto:mdm380@msstate.edu">mdm380@msstate.edu</a>
                        </p>
                      </Col> 
                      <Col span={3} offset={1}>
                        <Image src={mark} alt="mark" rootClassName="mt-3 teamimg"/>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={16} offset={2}>
                        <p className="mt-3"><b>Lee Hathcock,</b> Coordinator</p> 
                        <p className="mt-3">
                          Lee Hathcock is part of the CRP Menu project development team. He is a GIS & Database Coordinator at the Geosystems Research Institute. He does research in Geoinformatics (GIS), Remote Sensing and Electrical Engineering.
                          <br/><br/>
                          <i>Email:</i> <a className="email-address" href="mailto:hathcock@gri.msstate.edu">hathcock@gri.msstate.edu</a>
                        </p>
                      </Col> 
                      <Col span={3} offset={1}>
                        <Image src={lee} alt="lee" rootClassName="mt-3 teamimg"/>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={16} offset={2}>
                        <p className="mt-3"><b>Anthony Collini,</b> Developer</p> 
                        <p className="mt-3">
                          Anthony Collini is a Frontend Developer on the CRP Menu project, specializing in building interactive, data-driven web applications with a focus on performance and user experience. He has experience integrating geospatial data, developing scalable React-based interfaces, and creating intuitive tools that support conservation decision-making.
                          <br/><br/>
                          <i>Email:</i> <a className="email-address" href="mailto:collini.anthony@gmail.com">collini.anthony@gmail.com</a>
                        </p>
                      </Col>
                      <Col span={3} offset={1}>
                        <Image src={anthony} alt="anthony" rootClassName="mt-3 teamimg"/>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={16} offset={2}>
                        <p className="mt-3"><b>Daniel Egerson,</b> Graduate Student </p> 
                        <p className="mt-3">
                          Daniel Egerson is a Social Science Researcher for the CRP Menu project. He is a Graduate Research Assistant with the Department of Wildlife, Fisheries, and Aquaculture at Mississippi State University. His background is in Sociology and Population Study. He has experience engaging social science frameworks, methodologies, and qualitative and quantitative analysis in explaining the dynamics of human behavior. His interest is in humans and the environment, Urban and Rural Sociology, and special populations including migrant farmers and farming households.
                          <br/><br/>
                          <i>Email:</i> <a className="email-address" href="mailto:de631@msstate.edu">de631@msstate.edu</a>
                        </p>
                      </Col> 
                      <Col span={3} offset={1}>
                        <Image src={daniel} alt="daniel" rootClassName="mt-3 teamimg"/>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={16} offset={2}>
                        <p className="mt-3"><b>Dixie Cartwright,</b> Outreach Coordinator</p> 
                        <p className="mt-3">
                          Dixie Cartwright is a Training and External Facilitator with the Geosystems Research Institute. She specializes in designing and managing outreach initiatives, developing professional educational programs, and enhancing program and institute awareness through marketing and promotion efforts.
                          <br/><br/>
                          <i>Email:</i> <a className="email-address" href="mailto:dixie@gri.msstate.edu">dixie@gri.msstate.edu</a>
                        </p>
                      </Col> 
                      <Col span={3} offset={1}>
                        <Image src={dixie} alt="dixie" rootClassName="mt-3 teamimg"/>
                      </Col>
                    </Row>
                  </>
                )
              },
              {
                label: "Project Alumni",
                key: "2",
                children: (
                  <>
                    <Row>
                      <Col span={4} offset={1}>
                        <Image src={ethan} alt="ethan" rootClassName="mt-3 teamimg"/>
                        <p className="mt-3 alumni-name"><b>Yong (Ethan) Liang</b></p>
                      </Col>
                      <Col span={4} offset={1}>
                        <Image src={reshma} alt="reshma" rootClassName="mt-3 teamimg"/>
                        <p className="mt-3 alumni-name"><b>Reshma Devi Mandli</b></p>
                      </Col>
                      <Col span={4} offset={1}>
                        <Image src={leann} alt="leann" rootClassName="mt-3 teamimg"/>
                        <p className="mt-3 alumni-name"><b>Leann Hopper</b></p>
                      </Col>
                      <Col span={4} offset={1}>
                        <Image src={shannon} alt="shannon" rootClassName="mt-3 teamimg"/>
                        <p className="mt-3 alumni-name"><b>Shannon Westlake</b></p>
                      </Col>
                      <Col span={4} offset={1}>
                        <Image src={amanda} alt="amanda" rootClassName="mt-3 teamimg"/>
                        <p className="mt-3 alumni-name"><b>Amanda Sesser</b></p>
                      </Col>
                      <Col span={4} offset={1}>
                        <Image src={tracey} alt="tracey" rootClassName="mt-3 teamimg"/>
                        <p className="mt-3 alumni-name"><b>Tracey DuBard</b></p>
                      </Col>
                      <Col span={4} offset={1}>
                        <Image src={rishita} alt="rishita" rootClassName="mt-3 teamimg"/>
                        <p className="mt-3 alumni-name"><b>Rishita Garg</b></p>
                      </Col>
                      <Col span={4} offset={1}>
                        <Image src={sathish} alt="sathish" rootClassName="mt-3 teamimg"/>
                        <p className="mt-3 alumni-name"><b>Sathish Samiappan</b></p>
                      </Col>
                      <Col span={4} offset={1}>
                        <Image src={bradly} alt="bradly" rootClassName="mt-3 teamimg"/>
                        <p className="mt-3 alumni-name"><b>Bradly Thornton</b></p>
                      </Col>
                    </Row>
                  </>
                )
              }
            ]}
          />
        <Footer />
      </>
    );
}
export default ProjectTeam;